import { CheckIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import * as Select from '@radix-ui/react-select';
import React from 'react';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  isEditing: boolean;
  options: SelectOption[];
  formatter?: (value: string) => string;
}

export const SelectField: React.FC<SelectFieldProps> = ({
  label,
  value,
  onChange,
  isEditing,
  options,
  formatter,
}) => {
  return (
    <div className='flex justify-between items-center'>
      <span className='text-gray-600'>{label}:</span>
      {isEditing ? (
        <Select.Root value={value} onValueChange={onChange}>
          <Select.Trigger className='inline-flex items-center justify-between text-xs px-2 py-1.5 border border-gray-300 rounded hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 min-w-[120px] bg-white'>
            <Select.Value />
            <Select.Icon>
              <ChevronDownIcon className='w-3 h-3 ml-2' />
            </Select.Icon>
          </Select.Trigger>
          <Select.Portal>
            <Select.Content className='overflow-hidden bg-white rounded-md shadow-lg border border-gray-200 z-50'>
              <Select.Viewport className='p-1'>
                {options.map((opt) => (
                  <Select.Item
                    key={opt.value}
                    value={opt.value}
                    className='text-xs relative flex items-center px-6 py-2 rounded hover:bg-blue-50 hover:outline-none cursor-pointer select-none data-[highlighted]:bg-blue-50'
                  >
                    <Select.ItemIndicator className='absolute left-1 inline-flex items-center justify-center'>
                      <CheckIcon className='w-3 h-3 text-blue-600' />
                    </Select.ItemIndicator>
                    <Select.ItemText>{opt.label}</Select.ItemText>
                  </Select.Item>
                ))}
              </Select.Viewport>
            </Select.Content>
          </Select.Portal>
        </Select.Root>
      ) : (
        <span className='font-medium text-gray-800 uppercase'>
          {formatter ? formatter(value) : value}
        </span>
      )}
    </div>
  );
};
